import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Button } from '../ui/button'
import { useQueryClient } from '@tanstack/react-query'
import { getPlanFeatureSettingsPlanFeatureSettingsGetQueryKey } from '@/generated/@tanstack/react-query.gen'

interface Props {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

export default function TrialPaymentSuccess({ isOpen, onOpenChange }: Props) {
  const queryClient = useQueryClient()
  const handleClose = (isOpen: boolean) => {
    if (!isOpen) {
      onOpenChange(false)
      queryClient.invalidateQueries({
        queryKey: getPlanFeatureSettingsPlanFeatureSettingsGetQueryKey(),
      })
    }
  }
  const Content = () => {
    const localAuth = localStorage.getItem('auth')
      ? JSON.parse(localStorage.getItem('auth') || '{}')
      : {}
    const tier = localAuth.tier?.replace('-annual', '')

    return (
      <DialogContent showClose className="max-w-[440px] !p-8 rounded-lg">
        <DialogHeader>
          <DialogTitle className="md:text-2xl">Payment Successful</DialogTitle>
        </DialogHeader>
        <p>
          Welcome to Hydra Score <span className="font-bold">{tier}.</span>
        </p>
        <DialogFooter className="flex sm:flex-col gap-4">
          <Button
            className="h-14 w-full text-lg"
            onClick={() => handleClose(false)}
          >
            Enter
          </Button>
        </DialogFooter>
      </DialogContent>
    )
  }
  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <Content />
    </Dialog>
  )
}
